import { OrderRecheckResponse } from '../model/types/orderRecheckSchema';

/**
 * Checks if the recheck response contains any changes that require user attention
 */
export const hasOrderRecheckChanges = (data: OrderRecheckResponse): boolean => {
    const delta = Number.parseFloat(data.totalPriceDelta);
    const hasPriceChange = !Number.isNaN(delta) && delta !== 0;
    const hasSupplierChanges =
        (data.suppliersAdded?.length ?? 0) > 0 ||
        (data.suppliersRemoved?.length ?? 0) > 0;
    const hasUnavailableItems =
        (data.unavailableSelectedCount ?? 0) > 0 ||
        (data.unavailableSelectedShortageTotal ?? 0) > 0;

    return hasPriceChange || hasSupplierChanges || hasUnavailableItems;
};
